import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ICurrencyPairGroupLookupService } from "../ICurrencyPairGroupLookupService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { CcyPairLookupService } from "./CcyPairLookupService";

@Injectable()
export class CurrencyPairGroupLookupService
  extends BaseLookupService<string, CubiqTS.CurrencyPairGroupImpl>
  implements ICurrencyPairGroupLookupService
{
  constructor(public ccyPairService: CcyPairLookupService) {
    super(CubiqTS.CurrencyPairGroupImpl);
  }

  getItemKey(item: CubiqTS.CurrencyPairGroupImpl): string {
    if (
      item != null &&
      item instanceof CubiqTS.CurrencyPairGroupImpl &&
      CubiqTS.Long.isLong(item.id)
    ) {
      return item.id.toString();
    }

    return null;
  }

  public findByName(name: string): CubiqTS.CurrencyPairGroupImpl {
    return this.getAll().find((group) => group.currencypairGroupNm === name);
  }
}
